import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule, MatSlideToggleModule } from '@angular/material';

import { DbmAdditionalProprtiesOptionsComponent } from './dbm-additional-proprties.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatSelectModule,
        MatSlideToggleModule
    ],
    declarations: [DbmAdditionalProprtiesOptionsComponent],
    entryComponents: [DbmAdditionalProprtiesOptionsComponent],
    exports: [DbmAdditionalProprtiesOptionsComponent]
})
export class DbmAdditionalProprtiesOptionsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-proprties-additional-options/dbm-additional-proprties.module.ts